import { useStyles } from "./wrapper.style"
import { Container, CssBaseline } from "@fedsim/components"
import CookieConsent from "./consent"

import "./wrapper.css"

export default function LayoutWrapper({ children = "" }) {
  const classes = useStyles()

  return (
    <>
      <CssBaseline />
      <Container className={classes.root} disableGutters>
        <CookieConsent />
        <div className={classes.content}>{children}</div>
      </Container>
    </>
  )
}
